import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSessionStore } from '@/entities/session';
import { apiClient } from '@/shared/api';

// Errors are ignored: the local session is cleared regardless (production behaviour).
const logout = () => apiClient.get<void>('/auth/logout', { silent: true });

/** Tells the API (for login history), then clears local session and cached queries regardless. */
export function useLogout() {
  const clearSession = useSessionStore((s) => s.clearSession);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: logout,
    onSettled: () => {
      clearSession();
      queryClient.clear();
    },
  });
}
